export function renderIconFieldFormFieldTemplate({
  indent,
  fieldName,
  formItemProps,
  labelWithDescription,
  toLowerCase
}: {
  indent: string
  fieldName: string
  formItemProps: string
  labelWithDescription: string
  toLowerCase: string
}): string {
  return `${indent}<FormField
${indent}  control={form.control}
${indent}  name="${fieldName}"
${indent}  render={({ field: formField }) => (
${indent}    <FormItem${formItemProps}>
${indent}      ${labelWithDescription}
${indent}      <FormControl>
${indent}        <IconPicker
${indent}          value={formField.value}
${indent}          onValueChange={formField.onChange}
${indent}          triggerPlaceholder="Select ${toLowerCase}"
${indent}        />
${indent}      </FormControl>
${indent}      <FormMessage />
${indent}    </FormItem>
${indent}  )}
${indent}/>`
}
